import i18next from 'i18next';

export const formatAmount = (amount) => {
  return i18next.t('formatUtils.withCurrency', { amount });
};
